/**
 * ReturnToAppBanner — shown at top of User Center when the user arrived via SSO redirect.
 * Displays a "Return to App" button that generates an auth code and redirects back.
 */
import { useState, useEffect } from 'react';
import { authUtils } from '@lib/api';

export function ReturnToAppBanner() {
  const [returnUrl, setReturnUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const url = params.get('return_url');
    if (url) {
      setReturnUrl(url);
      // Store in sessionStorage so it survives navigation within User Center
      sessionStorage.setItem('sso_return_url', url);
    } else {
      // Check sessionStorage for preserved return_url
      const stored = sessionStorage.getItem('sso_return_url');
      if (stored) {
        setReturnUrl(stored);
      }
    }
  }, []);

  const handleReturn = async () => {
    if (!returnUrl) return;
    setLoading(true);
    try {
      const token = authUtils.getToken();
      const result = await fetch('/api/v1/sso/return', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ return_url: returnUrl }),
      });
      const data = await result.json();
      if (data.redirect_url) {
        // Clear stored return_url
        sessionStorage.removeItem('sso_return_url');
        window.location.href = data.redirect_url;
      }
    } catch {
      setLoading(false);
    }
  };

  if (!returnUrl) return null;

  return (
    <>
      {/* Spacer to push content below the fixed banner */}
      <div style={{ height: '40px' }} />
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        background: 'var(--nm-primary, #4f46e5)',
        color: '#fff',
        padding: '8px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontSize: '14px',
      }}>
        <span>您正在用户中心管理账号</span>
        <button
          onClick={handleReturn}
          disabled={loading}
          style={{
            background: 'rgba(255,255,255,0.2)',
            color: '#fff',
            border: '1px solid rgba(255,255,255,0.4)',
            borderRadius: '6px',
            padding: '4px 16px',
            cursor: loading ? 'not-allowed' : 'pointer',
            fontSize: '13px',
          }}
        >
          {loading ? '正在跳转...' : '返回应用'}
        </button>
      </div>
    </>
  );
}
